import { Box, CircularProgress, Backdrop } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ModalComponent from "./modalComponent";
import { useSnackbar } from "notistack";
import 'react-international-phone/style.css';
import SharedBlockChainAccCreation from "./common/SharedBlockChainAccCreation";


export default function SecondaryBlockchainAccountModal({ open, setOpen, user, dispatch , disableAlgorandOption = true ,disablePolygonOption = false, disableMstOption = false, fetchDltWallet}) {
    
    const [blockchainAccountDownload, setBlockchainAccountDownload] = useState(false);
    const [blockchainAccountCreated, setBlockchainAccountCreated] = useState(false);
    const [animating, setAnimating] = useState(false);
    const [openProgressBar, setOpenProgressBar] = useState(false);
    const [sendMail, setSendMail] = useState(true);
    const modelRef = useRef();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        console.log(user?.status);
        if (user?.status != "APPROVED") setOpen(false);
    }, [user?.status]);

    useEffect(() => {
        if (animating) {
            scrollToTop();
        }
    }, [animating])

    const customHandleClose = () => {
        if (!blockchainAccountCreated || blockchainAccountDownload) {
            setOpen(false);
            setBlockchainAccountCreated(false);
            fetchDltWallet();
        }
        else enqueueSnackbar("Please download key details before closing!", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 5000 })
    }

    const scrollToTop = () => {
        if (modelRef.current) {
            let modalBody = modelRef.current.querySelector('.MuiDialog-container')
            // console.log(modalBody)
            if (modalBody) {
                modalBody.scroll({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }

    return (
        <ModalComponent
            slotProps={{
                root: {
                    ref: modelRef
                }
            }}
            open={open}
            handleClose={customHandleClose}
            contentPadding={{ xs: 1, md: 1.25 }}
            PaperProps={{ sx: { textAlign: "center", overflow: "auto", width: { md: 480 }, maxWidth: "100%" } }}>
            <Backdrop open={openProgressBar} sx={{ color: "#ddd", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress
                    size={75}
                    thickness={4}
                    sx={{
                        position: "fixed",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2
                    }}
                    style={{ color: "#fff" }}
                />
            </Backdrop>
            <SharedBlockChainAccCreation
                entity={user}
                entityType="INVESTOR"
                customHandleClose={customHandleClose}
                setAnimating={setAnimating}
                setBlockchainAccountDownload={setBlockchainAccountDownload}
                blockchainAccountCreated={blockchainAccountCreated}
                setBlockchainAccountCreated={setBlockchainAccountCreated}
                disableAlgorandOption={true}
                disablePolygonOption={disablePolygonOption || !user?.dltPolicy?.polygon}
                disableMstOption={disableMstOption || !user?.dltPolicy?.mst}
                nicknamePlaceholder="Secondary Account"
                sendMail={sendMail}
                setSendMail={setSendMail}
            />
        </ModalComponent>
    )
}